/* eslint-disable max-len */
import React from 'react';
import { CContainer, CRow, CCol, CCard, CCardHeader, CCardBody, CBreadcrumb, CBreadcrumbItem } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import SupplierTypeInputs from '../../components/SupplierTypeInputs/SupplierTypeInputs';
import { createSupplierTypeRequestAction } from '../../store/supplierType/supplierTypeActions';
import { useTranslation } from '../../hooks/useTranslation';

const CreateSupplierType = ({ createSupplierTypeRequest, isLoading, createSupplierTypeData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = (data) => {
    createSupplierTypeRequest({ data, navigate });
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/suppliertype" onClick={(e) => { e.preventDefault(); navigate('/suppliertype'); }}>
          {t('supplierType')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createSupplierType')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createSupplierType')}</h4></CCardHeader>
            <CCardBody>
              <SupplierTypeInputs
                onSubmit={handleSubmit}
                onCancel={() => navigate('/suppliertype')}
                isLoading={isLoading}
                submitResponse={createSupplierTypeData}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading
});

export default connect(mapStateToProps, { createSupplierTypeRequest: createSupplierTypeRequestAction })(CreateSupplierType);


